import type { Quotation } from '../../types/sales/quotation';
import { fetchQuotationPdf } from './quotationApi';
import { printPdfBlob } from '../printPdfBlob';

/**
 * Prints the server-generated quotation PDF (same document as download/email).
 */
export const printQuotation = async (
  quotation: Pick<Quotation, 'id' | 'quotation_number'>
): Promise<void> => {
  const { blob } = await fetchQuotationPdf(
    quotation.id,
    `${quotation.quotation_number}.pdf`
  );
  await printPdfBlob(blob);
};
